// The function returns a string[][] where:
// - Each index is the column index.
// - Each array contains the unique string values for that column.

function getUniqueColumnValues(rows: (string | null)[][]): string[][] {
  const uniqueValues: {[colIdx: number]: Set<string>} = {};

  rows.forEach((row) => {
    row.forEach((value, colIdx) => {
      if (value !== null && value !== '') {
        if (!uniqueValues[colIdx]) {
          uniqueValues[colIdx] = new Set();
        }

        uniqueValues[colIdx].add(value);
      }
    });
  });

  const result: string[][] = [];
  const maxColIdx = Math.max(...Object.keys(uniqueValues).map(Number), 0);

  for (let colIdx = 0; colIdx <= maxColIdx; colIdx++) {
    result[colIdx] = uniqueValues[colIdx] ? Array.from(uniqueValues[colIdx]) : [];
  }

  return result;
}

export default getUniqueColumnValues;
